import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';
import reportWebVitals from './reportWebVitals';
import Transport from './common/services/api/Transport';
import { authFromQuery } from './common/utils/authFromQuery';
import './common/assets/styles/base.scss';
import './common/assets/styles/overdesigns.scss';

const renderBootstrapLoading = () => {
    const root = document.getElementById('root');
    if (!root) return;

    root.innerHTML =
        '<div style="display:flex;justify-content:center;align-items:center;min-height:100vh;font-family:Roboto,sans-serif;color:#666;">در حال بارگذاری...</div>';
};

async function bootstrap() {
    renderBootstrapLoading();

    const authResult = await authFromQuery();

    const transport = new Transport();
    const registeredToken = localStorage.getItem('token');
    if (registeredToken) {
        transport.rememberToken(registeredToken);
    }

    ReactDOM.render(
        <BrowserRouter>
            <App initialSsoError={authResult.status === 'failed' ? authResult.message : ''} />
        </BrowserRouter>,
        document.getElementById('root')
    );
}

bootstrap();

reportWebVitals();
